import React from 'react';
import { CardContainer } from '../../shared/components/card';
import { DatePickerInput } from '../../shared/components/datePicker';
import { TimePickerInput } from '../../shared/components/timePicker';

export class DateTimePickerDevelopmentPage extends React.Component {
  state = {
    date: undefined,
    range: undefined,
    locale: { name: 'en-US', lable: 'English (US)' },
    time: undefined,
    zoned: undefined,
  };

  padded(n: number): string {
    return n < 10 ? `0${n}` : `${n}`;
  }

  render(): JSX.Element {
    return (
      <div className='min-h-screen w-full bg-gray-lightest'>
        <div className='mx-auto w-3/4 py-20'>
          <h1>Date & Time Picker Development</h1>
          <CardContainer stripPadding={false}>
            {/* Start DatePicker Here */}
            <DatePickerInput
              id='datepicker_1'
              locale={this.state.locale.name}
              placeholder='MM/DD/YYYY'
              label='Date Picker Input'
              name='datePicker'
              className='mb-10'
              value={this.state.range}
              variant='double'
              selectionType='range'
              onChange={(value) => {
                this.setState({ range: value });
              }}
            />
            {/* End DatePicker Here */}

            {/* Start DatePicker Here */}
            <DatePickerInput
              id='datepicker_2'
              locale={this.state.locale.name}
              placeholder='MM/DD/YYYY'
              label='Date Picker Input'
              name='datePicker'
              className='mb-10'
              value={this.state.date}
              variant='single'
              selectionType='single'
              onChange={(value) => {
                this.setState({ date: value });
              }}
            />
            {/* End DatePicker Here */}

            {/* Start TimePicker Here */}
            <TimePickerInput
              id='tiempicker_1'
              label='Time Picker Input'
              name='timePicker_local'
              className='mb-10'
              placeholder='00:00 AM'
              value={this.state.time}
              onChange={(value) => this.setState({ time: value })}
            />

            <TimePickerInput
              id='tiempicker_1'
              label='Time Picker Input'
              name='timePicker_zoned'
              placeholder='00:00 AM'
              value={this.state.zoned}
              onChange={(value) => this.setState({ zoned: value })}
              zone='America/Halifax'
            />

            {/* {this.state.time} */}
            <div className='flex flex-col space-y-4 py-20'>
              <h2 className='mb-8'>DATES PLAYGROUND</h2>

              <h3>Local</h3>
              <p>{this.state.time && (this.state.time as Date).getTime()}</p>
              <p>
                {this.state.time && (this.state.time as Date).toISOString()}
              </p>
              <pre>{this.state.time && JSON.stringify(this.state.time)}</pre>
              {/* <p>
                {this.state.time &&
                  this.state.time instanceof DateTime &&
                  this.state.time.toISO()}
              </p>
              <p>
                {this.state.time &&
                  this.state.time instanceof DateTime &&
                  this.state.time.valueOf()}
              </p>
              <p>
                {this.state.time &&
                  this.state.time instanceof DateTime &&
                  this.state.time.toJSDate().toISOString()}
              </p> */}

              <h3>Zoned</h3>
              {/* <p>{this.state.zoned && this.state.zoned.toISO()}</p>
              <p>{this.state.zoned && this.state.zoned.valueOf()}</p>
              <p>
                {this.state.zoned && this.state.zoned.toJSDate().toISOString()}
              </p> */}
              <p>{this.state.zoned && (this.state.zoned as Date).getTime()}</p>
              <p>
                {this.state.zoned && (this.state.zoned as Date).toISOString()}
              </p>
              <pre>{this.state.zoned && JSON.stringify(this.state.zoned)}</pre>
            </div>
          </CardContainer>
        </div>
      </div>
    );
  }
}
